import React, { useEffect, useState, useRef } from "react";
import { marked } from "marked";
import { Text } from "../readme";

const Unboard: React.FC = () => {
const [currentVersion] = useState<string>("1.4");
const [isUnboarded, setIsUnboarded] = useState<boolean>(true);
const [openDialog, setOpenDialog] = useState<boolean>(false);
const [textHTML, setTextHTML] = useState<any>("");
const dialogRef = useRef<HTMLDialogElement | null>(null);

useEffect(() => {
setTextHTML(marked(Text));

const storedVersion = localStorage.getItem("currentVersion");
const storedUnboarded = localStorage.getItem("isUnboarded");

if (!storedUnboarded) {
setOpenDialog(true);
} else if (
storedVersion &&
parseFloat(storedVersion) < parseFloat(currentVersion)
) {
localStorage.setItem("currentVersion", currentVersion);
localStorage.setItem("isUnboarded", "true");
setIsUnboarded(true);
setOpenDialog(true);
}
}, [currentVersion]);

useEffect(() => {
if (openDialog && dialogRef.current) {
dialogRef.current.showModal();
}
}, [openDialog]);

const handleCloseDialog = () => {
if (dialogRef.current) dialogRef.current.close();
setOpenDialog(false);
localStorage.setItem("isUnboarded", "true");
localStorage.setItem("currentVersion", currentVersion);
};

return (
<>
<dialog
ref={dialogRef}
style={{ padding: "1rem", width: "90%", maxWidth: "500px" }}
aria-modal="true"
aria-label="Welcome to the new Update!"
>
<h2>The Site is updated to {currentVersion}</h2>
<button
onClick={handleCloseDialog}
style={{ marginTop: "1rem", padding: "0.5rem 1rem", cursor: "pointer" }}
>
Close
</button>
<div
dangerouslySetInnerHTML={{
__html: textHTML,
}}
/>
<button
onClick={handleCloseDialog}
style={{ marginTop: "1rem", padding: "0.5rem 1rem", cursor: "pointer" }}
>
Continue
</button>
</dialog>
</>
);
};

export default Unboard;
